export default "__VITE_ASSET__DfXO09JI__"